module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/error.27ff3f37.png";